import md5 from "md5";
import history from "../../components/pages/login/history";
// import { tokenAPI } from "./../../components/generico/utils/UrlAPI"
import axios, { AxiosResponse } from 'axios'
import { oauth } from "../../components/generico/utils/UrlAPI";
import { personas, transferencias } from "../../components/generico/utils/UrlAPI";
import Popup from "react-popup";
import ConfigService from "../configuracion/ConfigService";

const OAUTH_BASIC_AUTHORIZATION = "Basic Y3UyNGhzLXdlYjpDVSNyb290IXdlYg==";


class AuthService {

  init = () => {
    this.setInterceptors();
  };

  setInterceptors = () => {

    var token = JSON.parse(sessionStorage.getItem("user"));

    if (token != null) {
      axios.defaults.headers.common['access_token'] = token.access_token;
      axios.interceptors.response.use(response => {
        // console.log("CORRECTO");
        return response;
      }, error => {
        // console.log("ERROR");
        console.log("error interceptor auth", error);

        return new Promise((resolve, reject) => {

          const originalReq = error.config;
          if (error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
            var user = JSON.parse(sessionStorage.getItem("user"));

            if (user) {
              var refreshToken = user.refresh_token;
              //console.log("Refresh Token: " + refreshToken);
              if (refreshToken) {
                originalReq._retry = true;
                var qs = require("qs");
                var data = qs.stringify({
                  grant_type: "refresh_token",
                  refresh_token: refreshToken,
                });

                let res = fetch(oauth + "oauth/token", {
                  method: 'POST',
                  mode: 'cors',
                  cache: 'no-cache',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: OAUTH_BASIC_AUTHORIZATION
                  },
                  redirect: 'follow',
                  referrer: 'no-referrer',
                  body: data
                }).then(res => res.json()).then(res => {
                  if (res.error) {
                    //(res.error_description);
                    this.logout();
                  }

                  //console.log(res);
                  sessionStorage.setItem("user", JSON.stringify(res));
                  axios.defaults.headers['Authorization'] = "Bearer " + res.access_token;
                  originalReq.headers['Authorization'] = "Bearer " + res.access_token;

                  return axios(originalReq);

                });

                resolve(res);

              } else {
                //console.log("Refresh token not available.")
                this.logout();
              }

            } else {
              //console.log("Refresh token not available.")
              this.logout();
            }

          } else {
            return reject(error);
          }

        });
      });
    } else if (window.location.href.indexOf("pinAcceso") < 0) {
      history.push("/");
    }
  };

  //retorna el access_token luego de validar el challengeToken
  getAccessToken = ({
    imeiIp,
    cuenta,
    cedulaIdentidad,
    cambiar,
    ultimoAcceso,
    canal,
    nombreCompleto,
    identificador,
    jti,
    tokenChallenge,
    fingerprint,
    password,
    infoClient,
    tipoCuenta,
    username,
    numeroSocio
  }) => {

    sessionStorage.removeItem("user");
    sessionStorage.removeItem("socio");
    sessionStorage.removeItem("cedula");

    var qs = require("qs");

    var pass = md5(password);

    var data = qs.stringify({
      grant_type: "password",
      imeiIp,
      cuenta,
      cedulaIdentidad,
      cambiar,
      ultimoAcceso,
      canal,
      nombreCompleto,
      identificador,
      jti,
      tokenChallenge,
      fingerprint,
      password: pass,
      latitud: infoClient.latitud,
      longitud: infoClient.longitud,
      marcaNavegador: infoClient.marcaNavegador,
      modeloVersion: infoClient.modeloVersion,
      so: infoClient.so,
      tipoCuenta,
      username,
      numeroSocio
    });

    //console.log(data);

    var config = {
      method: "post",
      url: oauth + "oauth/token",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: OAUTH_BASIC_AUTHORIZATION,
      },
      data: data,
    };
    return axios(config);

  }

  // solo valida las credenciales, no retorna el access_token
  validarCredenciales = (usuario, cuenta, password, tipo, infoClient, fingerprint) => {

    sessionStorage.removeItem("user");
    sessionStorage.removeItem("socio");
    sessionStorage.removeItem("cedula");

    var qs = require("qs");

    var pass = md5(password);
    var data = qs.stringify({
      // var data = JSON.stringify({
      grant_type: "password",
      username: usuario,
      password: pass,
      cuenta: cuenta,
      tipoCuenta: tipo,
      canal: "WEB",
      imeiIp: infoClient.ip,
      latitud: infoClient.latitud,
      longitud: infoClient.longitud,
      marcaNavegador: infoClient.marcaNavegador,
      modeloVersion: infoClient.modeloVersion,
      so: infoClient.so,
      ultimoAcceso: infoClient.ultimoAcceso,
      fingerprint
    });

    //console.log(data);

    var config = {
      method: "post",
      url: oauth + "oauth/validate-credentials",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: OAUTH_BASIC_AUTHORIZATION,
      },
      data: data,
    };
    return axios(config);

  }

  login = (usuario, cuenta, password, tipo, infoClient) => {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("socio");
    sessionStorage.removeItem("cedula");

    var qs = require("qs");

    var pass = md5(password);
    var data = qs.stringify({
      // var data = JSON.stringify({
      grant_type: "password",
      username: usuario,
      password: pass,
      cuenta: cuenta,
      tipoCuenta: tipo,
      canal: "WEB",
      imeiIp: infoClient.ip,
      latitud: infoClient.latitud,
      longitud: infoClient.longitud,
      marcaNavegador: infoClient.marcaNavegador,
      modeloVersion: infoClient.modeloVersion,
      so: infoClient.so,
      ultimoAcceso: infoClient.ultimoAcceso
    });

    //console.log(data);

    var config = {
      method: "post",
      url: oauth + "oauth/token",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: OAUTH_BASIC_AUTHORIZATION,
      },
      data: data,
    };
    return axios(config);
  };

  resetPin(cedula, claveNueva, claveActual) {
    var token = this.getCurrentToken();
    var data = JSON.stringify({
      // dato: dato,
      // clave: "",
      // tipo: "D",
      cedulaIdentidad: cedula,
      canal: "WEB",
      claveTemporal: md5(claveActual),
      claveActual: md5(claveNueva),
    });
    var config = {
      method: "post",
      // url: "resetpin2/?access_token=" + token,
      url: personas + "claves/cambiar-temporal",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return axios(config).then((response) => {
      return JSON.stringify(response.data);
    });
  }

  async resetPinAcceso(dato, claveNueva, claveActual) {
    var data = JSON.stringify({
      canal: "WEB",
      pinActual: md5(claveActual),
      pinNuevo: md5(claveNueva)
    });

    var config = {
      method: "post",
      url: personas + "claves/cambiar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getCurrentToken()
      },

      data: data,
    };

    return await axios(config);
  }

  notifiPopup2 = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Cerrar",
            className: "secundary",
            action: function () {
              Popup.close();
            },
          },
          {
            text: "Continuar",
            className: "success",
            action: function () {
              //history.push("/datosPersonales");
              history.push(ConfigService.getPathByName("datosPersonales")?.url);
              window.location.reload();
              Popup.close();
            },
          },
        ],
      },
    });

  async loadSocio(token) {
    var config = {
      method: "get",
      url: personas + "datos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };
    await axios(config)
      .then(function (response) {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        // console.log(response);
        if (jData.codigo === 0) {
          //var data = JSON.stringify(response.data);
          var usuario = JSON.parse(sessionStorage.getItem("user"));
          var data = JSON.stringify({
            username: usuario.cedulaIdentidad,
            numeroCedula: usuario.cedulaIdentidad,
            numeroSocio: usuario.numeroSocio,
            nombreCompleto: usuario.nombreCompleto,
            calificacion: null,
            idPersona: String(response.data.datos.idPersona),
            correoElectronico: response.data.datos.correoElectronico,
            telefonoParticular: response.data.datos.telefonoParticular,
            celular: response.data.datos.celular,
            direccionParticular: response.data.datos.direccionParticular,
            departamento: response.data.datos.departamento,
            ciudad: response.data.datos.ciudad,
            barrio: response.data.datos.barrio,
            entidadLaboral: response.data.datos.entidadLaboral,
            cargo: response.data.datos.cargo,
            puestoPublico: response.data.datos.puestoPublico,
            mostrar: response.data.datos.mostrar,
            presentadoPEPS: response.data.datos.presentadoPEPS,
            canal: "WEB",
            latitud: response.data.datos.latitud,
            longitud: response.data.datos.longitud,
            ruc: response.data.datos.ruc
          });

          sessionStorage.setItem("socio", data);
          if (response.data.datos.mostrar === "S" && history.location.pathname === "/resumenGeneralSocio") {
            Popup.queue(
              this.notifiPopup2("Aviso al Socio", "POR MOTIVOS DE SEGURIDAD, SOLICITAMOS QUE MANTENGA ACTUALIZADOS SUS DATOS PERSONALES.")
            );
          }
        } else {
          sessionStorage.setItem("socio", null);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  async debeCambiarPinTransaccional() {
    // var token = this.getCurrentToken();
    // var cedula = sessionStorage.getItem("cedula");

    // var data = JSON.stringify({
    // cedulaSocio: cedula,
    // });
    var config = {
      method: "get",
      url: transferencias + "pines/consultas-cambiar" + "?canal=WEB",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getCurrentToken()
      },
      // data: data,
    };
    return axios(config).then((response) => {
      return JSON.stringify(response.data);
    });
  }

  async confirmarCambioPinTransaccional(pinAnterior, pinNueva) {
    // var token = this.getCurrentToken();
    // var cedula = sessionStorage.getItem("cedula");

    var data = JSON.stringify({
      pinTemporal: md5(pinAnterior),
      pinNuevo: md5(pinNueva),
      canal: "WEB",
    });
    var config = {
      method: "post",
      url: transferencias + "pines/cambiar-tmp",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getCurrentToken(),
      },
      data: data,
    };
    return axios(config).then((response) => {
      return JSON.stringify(response.data);
    });
  }

  async cambiarPinTransaccional(pinAnterior, pinNueva) {
    // var usuario = this.getSocio();
    var data = JSON.stringify({
      pinActual: md5(pinAnterior),
      pinNuevo: md5(pinNueva),
      canal: "WEB",
    });

    var config = {
      method: "post",
      url: transferencias + "pines/cambiar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getCurrentToken(),
      },

      data: data,
    };
    // console.log(data);
    return await axios(config);
  }

  refreshToken(_refresh_token) {
    // async refreshToken(_refresh_token) {
    //console.log("EN REFRESH TOKEN");
    var refreshToken = this.getRefreshToken();
    var qs = require("qs");
    var data = qs.stringify({
      // var data = JSON.stringify({
      grant_type: "refresh_token",
      refresh_token: refreshToken
    });

    var config = {
      method: "post",
      url: oauth + "oauth/token",
      // url: tokenAPI+"token/?grant_type=refresh_token&refresh_token=" + token,
      headers: {
        "Content-Type": "application/json",
        Authorization: OAUTH_BASIC_AUTHORIZATION,
      },
      data: data
    };
    return axios(config);
  }

  async logout() {
    sessionStorage.removeItem("mostrarAviso");
    var config = {
      method: "post",
      url: oauth + "oauth/revoke-token",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getCurrentToken(),
      },

    };

    return axios(config).then((response) => {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("socio");
      sessionStorage.removeItem("cambio");
      sessionStorage.removeItem("cedula");
      sessionStorage.removeItem("temporal");
      sessionStorage.removeItem("temporal");
      sessionStorage.removeItem("AH");
      sessionStorage.removeItem("tipo");
      sessionStorage.removeItem("resumen");
      sessionStorage.removeItem("deuda");
      sessionStorage.clear();
      history.push("/");
      window.location.reload();
    });

  }

  getCurrentUser() {
    return JSON.parse(sessionStorage.getItem("user"));
  }

  getCurrentToken() {
    var token = JSON.parse(sessionStorage.getItem("user"));
    return token.access_token;
  }

  getRefreshToken() {
    var token = JSON.parse(sessionStorage.getItem("user"));
    return token.refresh_token;
  }

  getSocio() {
    var socio = JSON.parse(sessionStorage.getItem("socio"));
    if (socio === null) {
      this.loadSocio(this.getCurrentToken());
    }
    return socio === null ? undefined : socio;
  }

  getBasicSocio() {
    var socio = JSON.parse(sessionStorage.getItem("user"));
    return socio;
  }

  getIsNewUser() {
    return sessionStorage.getItem("cambio");
  }

  getIsReset() {
    return sessionStorage.getItem("reset");
  }

  getCurrentUser() {
    return JSON.parse(sessionStorage.getItem("user"));
  }

  getCurrentToken() {

    if (sessionStorage.getItem("user") === null)
      return "";

    var token = JSON.parse(sessionStorage.getItem("user"));
    return token.access_token;
  }
  getCISocio() {

    if (sessionStorage.getItem("user") === null)
      return "";

    var token = JSON.parse(sessionStorage.getItem("user"));
    return token.cedulaIdentidad;
  }

  async verificaTienePin() {

    var config = {
      method: "get",
      url: transferencias + "pines/existe-pin-transferencia",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getCurrentToken()
      }
    };
    return await axios(config);
  }

}

export default new AuthService();
